import React, { useMemo } from "react";
import { IFieldOption, IStateProvinceFieldProps } from "../../../models";
import useFormContext from "../../../FormContext";
import usePromiseState from "../../../../../shared/usePromiseState";
import SelectField from "../../SelectField";

const getList = (locale: string = 'en-US'): Promise<IFieldOption[]> => {
  const country = locale.length === 5 ? locale.toUpperCase().substr(3) : 'US';
  switch (country) {
    case 'US': return import(/* webpackChunkName: "stateProvinces-us" */ "./locales/US.json").then(m => m.default);
    case 'CA': return import(/* webpackChunkName: "stateProvinces-ca" */"./locales/CA.json").then(m => m.default);
    case 'GB': return import(/* webpackChunkName: "stateProvinces-gb" */"./locales/GB.json").then(m => m.default);
    default: return Promise.reject(new Error("Unsupported locale: " + locale));
  }
}


const StateProvinceField: React.FC<IStateProvinceFieldProps> = (props) => {
  const { locale, isPrinting } = useFormContext();
  const promise = useMemo(() => isPrinting ? Promise.resolve([]) : getList(locale), [isPrinting, locale]);
  const [isLoading, result] = usePromiseState(promise);

  return (
      <SelectField {...props} options={result || []} isLoading={isLoading} />
  );
}


export default StateProvinceField;
